import * as actionTypes from '../../actionTypes';
import createReducer from '../../../../common/utils/createReducer';
import * as adminTypes from '../../../../common/actionTypes/adminTypes';
import * as translationTypes from '../../../../common/actionTypes/translationsActionTypes';
import get from 'lodash/get';
import { CHECKLIST, EXIT, WIDGET_TYPES } from '../../constants';
import isEmpty from 'lodash/isEmpty';

const INITIAL_STATE = {
  isCityCountryLoading: false,
  isCardLoading: true,
  isLeadCreating: false,
  isLeadSuccess: false,
  isHotelNameLoading: false,
  cityCountryData: [],
  hotelNameData: [],
  cardData: {},
  propertyClusterInfo: {},
  cityList: {},
  countryList: {},
  propertyType: {},
  geoLocation: {},
  cityCountry: '',
  hotelName: '',
  selectedHotel: null,
  roomCategories: [],
  roomCategoriesInfo: [],
  successScreenData: [],
  isSuccessScreenLoading: false,
  //new
  isPropertyTypeWidgetLoading: true,
  propertyTypeWidget: {},
  exitScreenWidget: {},
  isReverseGeoLocationFetching: false,
  geoLocationClosest: {},
  propertyInfoWidgetData: [],
  isAnotherUserPresent: false,
  isPropertyInfoWidgetDataLoading: false,
  checklistNavigationWidget: {},
  isChecklistNavigationWidgetLoading: false,
  referralData: {
    verifiedData: {
      details: {},
      isLoading: false,
      isError: false
    },
    isLoading: false
  },
  referralWidget: {},
  referralHeader: {},
  revenueWaiverData: {}
};
const reducer = {
  [adminTypes.SIGNOUT_USER_ON_AUTHENTICATION_FAIL]: (state, action) => INITIAL_STATE,
  [actionTypes.GET_CLUSTER_HEIRARCHY]: (state, action) => {
    const { clusterInfo } = action.payload;
    return {
      ...state,
      propertyClusterInfo: clusterInfo
    };
  },
  [actionTypes.SET_CITY_COUNTRY_LOADING_STATUS]: (state, action) => ({
      ...state,
      isCityCountryLoading: true
    }),
  [actionTypes.SET_HOTEL_NAME_LOADING_STATUS]: (state, action) => ({
      ...state,
      isHotelNameLoading: true
    }),
  [actionTypes.FETCH_CITY_COUNTRY_DATA]: (state, action) => {
    const { cityCountryData } = action.payload;
    return {
      ...state,
      cityCountryData: cityCountryData,
      isCityCountryLoading: false
    };
  },
  [actionTypes.CREATE_LEAD]: (state, action) => ({
      ...state,
      isLeadCreating: true
    }),
  [actionTypes.CREATE_LEAD_SUCCESS]: (state, action) => ({
      ...state,
      isLeadCreating: false,
      isLeadSuccess: true
    }),
  [actionTypes.CREATE_LEAD_FAILED]: (state, action) => ({
      ...state,
      isLeadCreating: false,
      isLeadSuccess: false
    }),
  [actionTypes.FETCH_CITY_COUNTRY_DATA_FAILED]: (state, action) => ({
      ...state,
      isCityCountryLoading: false
    }),
  [actionTypes.FETCH_HOTEL_NAME_DATA]: (state, action) => {
    const { hotelNameData } = action.payload;
    return {
      ...state,
      hotelNameData: hotelNameData,
      isHotelNameLoading: false
    };
  },
  [actionTypes.FETCH_HOTEL_NAME_DATA_FAILED]: (state, action) => ({
      ...state,
      isHotelNameLoading: false
    }),
  [actionTypes.FETCH_PROPERTY_DETAILS_FOR_CARD_FAILED]: (state, action) => ({
      ...state,
      isCardLoading: false,
      cardData: {}
    }),
  [actionTypes.FETCH_PROPERTY_DETAILS_FOR_CARD]: (state, action) => {
    const { cardData } = action.payload;
    return {
      ...state,
      cardData: cardData,
      isCardLoading: false
    };
  },
  [actionTypes.FETCH_CITY_LIST]: (state, action) => {
    const { cityList } = action.payload;
    return {
      ...state,
      cityList: cityList
    };
  },
  [actionTypes.FETCH_COUNTRY_LIST]: (state, action) => {
    const { countryList } = action.payload;
    return {
      ...state,
      countryList: countryList
    };
  },
  [actionTypes.FETCH_STATIC_DATA]: (state, action) => {
    const { propertyType } = action.payload;
    return {
      ...state,
      propertyType: propertyType
    };
  },
  //new
  [actionTypes.START_FETCHING_PROPERTY_TYPE_WIDGET]: (state, action) => ({
      ...state,
      isPropertyTypeWidgetLoading: true
    }),
  [actionTypes.FETCH_PROPERTY_TYPE_PAGE_WIDGETS]: (state, action) => {
    const { propertyTypeWidget } = action.payload;
    return {
      ...state,
      propertyTypeWidget: propertyTypeWidget,
      isPropertyTypeWidgetLoading: false
    };
  },
  [actionTypes.ERROR_FETCHING_PROPERTY_TYPE_WIDGET]: (state, action) => ({
      ...state,
      isPropertyTypeWidgetLoading: false
    }),
  [actionTypes.EXIT_SCREEN_WIDGET]: (state, action) => {
    const { exitScreenWidget } = action.payload;
    return {
      ...state,
      exitScreenWidget: exitScreenWidget
    };
  },

  //old
  [actionTypes.FETCH_PROPERTY_DETAILS_WIDGET]: (state, action) => {
    const { propertyDetailsWidget } = action.payload;
    return {
      ...state,
      propertyDetailsWidget: propertyDetailsWidget
    };
  },
  //NEW
  [actionTypes.START_FETCHING_REVERSE_GEOLOCATION]: (state, action) => ({
      ...state,
      isReverseGeoLocationFetching: true,
      geoLocationClosest: {},
      geoLocation: {}
    }),
  [actionTypes.FETCH_REVERSE_GEOLOCATION]: (state, action) => {
    const { geolocationAddress, geoLocationClosest } = action.payload;
    return {
      ...state,
      geoLocationClosest: geoLocationClosest,
      geoLocation: geolocationAddress,
      isReverseGeoLocationFetching: false
    };
  },
  [actionTypes.ERROR_FETCHING_REVERSE_GEOLOCATION]: (state, action) => ({
      ...state,
      isReverseGeoLocationFetching: false
    }),
  //OLD
  [actionTypes.PERSIST_PROPERTY_SEARCH_DATA]: (state, action) => {
    const { cityCountry, hotelName, selectedHotel } = action.payload;
    return {
      ...state,
      cityCountry: cityCountry,
      hotelName: hotelName,
      selectedHotel: selectedHotel
    };
  },
  [actionTypes.SET_CITY_COUNTRY_NAME]: (state, action) => {
    const { cityCountry } = action.payload;
    return {
      ...state,
      cityCountry: cityCountry,
      hotelNameData: []
    };
  },
  [actionTypes.SET_SELECTED_CITY_COUNTRY]: (state, action) => {
    const { cityCountry } = action.payload;
    return {
      ...state,
      selectedCityCountry: cityCountry
    };
  },
  [actionTypes.SET_LOCATION_DETAILS]: (state, action) => {
    const { location } = action.payload;
    return {
      ...state,
      selectedLocation: location
    };
  },
  [actionTypes.SET_SEARCH_OPTIONS]: (state, action) => {
    const { searchOptions } = action.payload;
    return {
      ...state,
      searchOptions: searchOptions
    };
  },
  [actionTypes.SET_ADDRESS]: (state, action) => {
    const { address } = action.payload;
    return {
      ...state,
      address: address
    };
  },
  [actionTypes.SET_HOTEL_NAME]: (state, action) => {
    const { hotelName } = action.payload;
    return {
      ...state,
      hotelName: hotelName
    };
  },
  [actionTypes.CLEAR_PERSISTED_DATA]: (state, action) => INITIAL_STATE,
  [actionTypes.SET_SELECTED_HOTEL]: (state, action) => {
    const { selectedHotel } = action.payload;
    return {
      ...state,
      selectedHotel: selectedHotel
    };
  },
  [actionTypes.RESET_CITY_COUNTRY_DATA]: (state, action) => ({
      ...state,
      cityCountryData: []
    }),
  [actionTypes.RESET_HOTEL_NAME_DATA]: (state, action) => ({
      ...state,
      hotelNameData: []
    }),
  [actionTypes.SET_COMPLETION_PAGE_DATA_LOADING]: (state, action) => {
    const { isLoading } = action.payload;
    return {
      ...state,
      isSuccessScreenLoading: isLoading
    };
  },
  [actionTypes.SAVE_COMPLETION_PAGE_DATA]: (state, action) => {
    const { data } = action.payload;
    return {
      ...state,
      successScreenData: data,
      isSuccessScreenLoading: false
    };
  },
  [actionTypes.FETCH_PROPERTY_INFO_WIDGET_SUCCESS]: (state, action) => {
    const { propertyInfoWidgetData } = action.payload;
    return {
      ...state,
      isPropertyInfoWidgetDataLoading: false,
      propertyInfoWidgetData
    };
  },
  [actionTypes.SAVE_DISCOUNT_WAIVER_DATA]: (state, action) => {
    const { item } = action.payload;
    return {
      ...state,
      revenueWaiverData: item
    };
  },
  [actionTypes.START_FETCHING_PROPERTY_INFO_WIDGET]: (state, action) => ({
      ...state,
      isPropertyInfoWidgetDataLoading: true
    }),
  [actionTypes.FETCH_PROPERTY_INFO_WIDGET_FAILED]: (state, action) => {
    const { propertyInfoWidgetData } = action.payload;
    return {
      ...state,
      isPropertyInfoWidgetDataLoading: false,
      propertyInfoWidgetData
    };
  },
  [actionTypes.START_FETCHING_CHECKLIST_NAVIGATION_WIDGET]: (state, action) => ({
      ...state,
      isChecklistNavigationWidgetLoading: true
    }),
  [actionTypes.SAVE_CHECKLIST_NAVIGATION_WIDGET]: (state, action) => {
    const widgetList = get(action.payload, 'data.widget_list', []);
    let exitScreenWidget = state.exitScreenWidget;
    let checklistNavigationWidget = {};
    let referralWidget = {};
    let referralHeader = {};
    for (const key in widgetList) {
      const contents = widgetList[key].contents;
      switch (widgetList[key].widget_type) {
        case CHECKLIST:
          checklistNavigationWidget = contents;
          break;
        case EXIT:
          exitScreenWidget = contents;
          break;
        case WIDGET_TYPES.REFERRAL_HEADER:
          referralHeader = contents;
          break;
        case WIDGET_TYPES.REFERRAL_CONFIRMATION:
          referralWidget = { ...referralWidget, confirmation: contents };
          break;
        case WIDGET_TYPES.REFERRAL_THANKS:
          referralWidget = { ...referralWidget, thanks: contents };
          break;
        case WIDGET_TYPES.REFERRAL_INPUT:
          referralWidget = { ...referralWidget, input: contents };
          break;
        case WIDGET_TYPES.REFERRAL_POPUP:
          referralWidget = { ...referralWidget, popup: contents };
          break;
        default:
      }
    }
    return {
      ...state,
      isChecklistNavigationWidgetLoading: false,
      checklistNavigationWidget: checklistNavigationWidget,
      exitScreenWidget: exitScreenWidget,
      referralWidget,
      referralHeader
    };
  },
  [actionTypes.ERROR_FETCHING_CHECKLIST_NAVIGATION_WIDGET]: (state, action) => ({
      ...state,
      isChecklistNavigationWidgetLoading: false
    }),
  [actionTypes.GET_USER_BY_EMAIL_OR_PHONE_SUCCESS]: (state, action) => {
    const { isAnotherUserPresent } = action.payload;
    return {
      ...state,
      isAnotherUserPresent
    };
  },
  [actionTypes.CREATE_OR_UPDATE_PROPERTY_SUCCESS]: (state, action) => ({
      ...state,
      address: {},
      hotelName: ''
    }),
  [actionTypes.VERIFY_REFERRAL_CODE_START]: state => ({
      ...state,
      referralData: {
        verifiedData: {
          details: {},
          isLoading: true,
          isError: false
        },
        isLoading: false
      }
    }),
  [actionTypes.VERIFY_REFERRAL_CODE_SUCCESS]: (state, action) => {
    const data = get(action, 'payload.data', {});
    return {
      ...state,
      referralData: {
        verifiedData: {
          details: data,
          isLoading: false,
          isError: isEmpty(data)
        },
        isLoading: false
      }
    };
  },
  [actionTypes.VERIFY_REFERRAL_CODE_CLEAR]: state => ({
      ...state,
      referralData: INITIAL_STATE.referralData
    }),
  [actionTypes.UPDATE_REFERRAL_LOADING]: (state, action) => ({
      ...state,
      referralData: {
        ...state.referralData,
        isLoading: get(action, 'payload.isLoading', false)
      }
    }),
  [actionTypes.UPDATE_COMMON_WIDGETS]: (state, action) => {
    const { widgetList = [] } = action.payload;
    let referralWidget = {};
    let referralHeader = {};
    for (const key in widgetList) {
      const contents = widgetList[key].contents;
      switch (widgetList[key].widget_type) {
        case WIDGET_TYPES.REFERRAL_HEADER:
          referralHeader = contents;
          break;
        case WIDGET_TYPES.REFERRAL_CONFIRMATION:
          referralWidget = { ...referralWidget, confirmation: contents };
          break;
        case WIDGET_TYPES.REFERRAL_THANKS:
          referralWidget = { ...referralWidget, thanks: contents };
          break;
        case WIDGET_TYPES.REFERRAL_INPUT:
          referralWidget = { ...referralWidget, input: contents };
          break;
          case WIDGET_TYPES.REFERRAL_POPUP:
            referralWidget = { ...referralWidget, popup: contents };
            break;
        default:
      }
    }
    return {
      ...state,
      referralWidget,
      referralHeader
    };
  },
  [translationTypes.CLEAR_REDUCERS]: (state, action) => INITIAL_STATE
};

export default createReducer(INITIAL_STATE, reducer);
